var map = {
	"./allDone.svg": 1572,
	"./danger.svg": 5318,
	"./eng.svg": 3283,
	"./est.svg": 744,
	"./fin.svg": 934,
	"./footerLogo.svg": 8438,
	"./login_img.svg": 4271,
	"./logo.svg": 2835,
	"./rus.svg": 2245,
	"./smallLogo.svg": 8272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;